import { FixedSizeVirtualScrollStrategy } from '@angular/cdk/scrolling';
import { Location } from '@angular/common';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ObserveOnMessage } from 'rxjs/internal/operators/observeOn';
import { filter, map } from 'rxjs/operators';
import {
  Application,
  ApplicationApi,
} from 'src/app/shared/models/header/application.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GeneralService {
  SubCategoryGet() {
    throw new Error('Method not implemented.');
  }

  showLang = new BehaviorSubject(false);
  crntLanguage = new BehaviorSubject(0);

  previousUrl;
  currentUrl;
  supportURL = 'https://mxsupport.mobilisepro.com/Webservices';
  constructor(
    private http: HttpClient,
    private location: Location,
    private router: Router
  ) {
    this.currentUrl = this.router.url;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;
      });
  }

  prevUrl(): any {
    return this.previousUrl;
  }

  back(): void {
    const rout = this.prevUrl().split('?');
    if (rout[0] == '/auth') {
      this.router.navigateByUrl('/dashboard');
    } else {
      this.location.back();
    }
  }

  oldSystem(): Observable<any[]> {
    return this.http.post<any[]>(`${environment.apiUrl}/old_system_sso_login`, {
      from: 'helpline_covid19',
    });
  }

  ssoLogin(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/old_system_sso_login`,
      req
    );
  }

  getEmps(req): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/emp_search`, req);
  }
  getEmpsAll(req): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/emp_search_all`, req);
  }
  getVendors(req): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/vendor_search_all`, req);
  }

  getApplicationRoutes(route): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_application_routes/` + route
    );
  }

  getActiveProject(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_project`);
  }
  getActiveApplication(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_application`);
  }
  getCcIdByCode(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/get_cc_id_by_code`,
      req
    );
  }
  // tslint:disable-next-line: typedef
  getCountry() {
    return new Promise((resolve) => {
      this.http.get(`${environment.apiUrl}/get_country`).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/get_country`);
  }

  // tslint:disable-next-line: typedef
  getCountryRegion(id) {
    return new Promise((resolve) => {
      this.http.get(`${environment.apiUrl}/get_region/` + id).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/get_region/` + id);
  }

  // tslint:disable-next-line: typedef
  getCountryState(id) {
    return new Promise((resolve) => {
      this.http.get(`${environment.apiUrl}/get_states/` + id).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });

    // return this.http.get<any[]>(`${environment.apiUrl}/get_states/` + id);
  }
  getYoutube(youtubeId: BigInteger): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/jobs/get_youtube` + '?youtubeId=' + youtubeId
    );
  }

  getCountryDivision(id) {
    return new Promise((resolve) => {
      this.http.get(`${environment.apiUrl}/get_divisions/` + id).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/get_divisions/` + id);
  }

  // tslint:disable-next-line: typedef
  getCountryCity(id) {
    return new Promise((resolve) => {
      this.http.get(`${environment.apiUrl}/get_city/` + id).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/get_city/` + id);
  }

  // tslint:disable-next-line: typedef
  getCountryPincode(id) {
    return new Promise((resolve) => {
      this.http.get(`${environment.apiUrl}/get_pincode/` + id).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/get_pincode/` + id);
  }

  getSysLogs(typeID, txnID, subTxnID, tbl): Observable<any[]> {
    if (typeID == '' || typeID == undefined || typeID == null) {
      typeID = 0;
    }
    if (txnID == '' || txnID == undefined || txnID == null) {
      txnID = 0;
    }
    if (subTxnID == '' || subTxnID == undefined || subTxnID == null) {
      subTxnID = 0;
    }
    if (tbl == '' || tbl == undefined || tbl == null) {
      tbl = 0;
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/logs/get_txn_logs/` +
        typeID +
        '/' +
        txnID +
        '/' +
        subTxnID +
        '/' +
        tbl
    );
  }
  getApplications(): Observable<Application[]> {
    return this.http
      .get<ApplicationApi>(`${environment.apiUrl}/get_role_app`)
      .pipe(map((res) => res.data));
  }

  getApplicationGroup(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/app-menu/get_sel_app_grp`
    );
  }

  getModuleGrp(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_group_gift`);
  }

  getModuleOption(modulegrpID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_options_mod/` + modulegrpID
    );
  }
  getModuleDpndntOption(ID): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_dpndt_options/` + ID
    );
  }

  // tslint:disable-next-line: typedef
  getMenu(appID) {
    return new Promise((resolve) => {
      this.http.get(`${environment.apiUrl}/get_app_menu/` + appID).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/get_app_menu/` + appID);
  }

  getSubmenu(mnuID): any {
    return new Promise((resolve) => {
      this.http
        .get(`${environment.apiUrl}/get_menu_submenu/` + mnuID)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            resolve(false);
          }
        );
    });
    // return this.http.get<any>(`${environment.apiUrl}/get_menu_submenu/` + mnuID);
  }

  getEventsList(): Observable<any[]> {
    return this.http.get<any>(`${environment.apiUrl}/select_event`);
  }

  getMenuMul(appData): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/get_application_menu_mul`,
      appData
    );
  }

  getSubMenuMul(menuData): Observable<any[]> {
    return this.http.post<any>(
      `${environment.apiUrl}/get_menu_sub_menu_mul`,
      menuData
    );
  }

  getRoles(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/get_role`);
  }
  getOwnedRoles(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/get_owned_role`);
  }

  getMasterUser(): Observable<any[]> {
    return this.http.get<any>(`${environment.apiUrl}/get_master_user`);
  }

  searchEmployee(empID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/search_emp_by_id/` + empID
    );
  }
  searchEmployeeExit(empID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/search_emp_by_id_exit/` + empID
    );
  }

  searchEmployeeMapped(empID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/search_emp_by_id_mapped/` + empID
    );
  }

  searchEmployeeAll(empID): Observable<any> {
    return this.http.get<any>(
      `${environment.apiUrl}/search_emp_by_id_all/` + empID
    );
  }

  updateUserDetail(data): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/update_user_detail`,
      data
    );
  }

  getOrgEmployees(orgID): Observable<any[]> {
    return this.http.get<any>(
      `${environment.apiUrl}/get_org_employees/` + orgID
    );
  }
  getOrg(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_org_name`);
  }
  getOrgSegments(OrgID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_org_segments/` + OrgID
    );
  }
  getOrgRegions(OrgID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_org_regions/` + OrgID
    );
  }
  getUserOrgRegions(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_user_org_regions`);
  }

  getCategory(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_category`);
  }

  getSegment(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_segment`);
  }
  getSubSegment(segId): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/select_subsegment/` + segId
    );
  }
  getAllRegion(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_region`);
  }
  // tslint:disable-next-line: typedef
  getSubCategory(catID) {
    return new Promise((resolve) => {
      this.http
        .post(`${environment.apiUrl}/select_sub_category`, catID)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            resolve(false);
          }
        );
    });
    // return this.http.post<any[]>(`${environment.apiUrl}/select_sub_category  `, catID);
  }

  // tslint:disable-next-line: typedef
  getSubChildCategory(subCategID) {
    return new Promise((resolve) => {
      this.http
        .post(`${environment.apiUrl}/select_sub_child_category`, subCategID)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            resolve(false);
          }
        );
    });
    // return this.http.post<any[]>(`${environment.apiUrl}/select_sub_child_category  `, subCategID);
  }
  // tslint:disable-next-line: typedef
  getOrgPlant(orgID) {
    return new Promise((resolve) => {
      // tslint:disable-next-line: deprecation
      this.http.get(`${environment.apiUrl}/get_plants/` + orgID).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/get_plants/` + orgID);
  }

  getProfitCenter(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_org_profitcenter`);
  }

  getMrfOptions(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_mrf_options`);
  }

  getMrfStatus(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_mrf_status`);
  }

  getTimezones(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_timezones`);
  }

  getCurrency(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_currencies`);
  }

  getLanguage(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_languages`);
  }

  getQualification(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_qual_list`);
  }
  getGenders(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_genders`);
  }
  getExpList(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_exp_list`);
  }

  delAddress(id): Observable<any[]> {
    return this.http.delete<any[]>(
      `${environment.apiUrl}/delete_address/` + id
    );
  }
  getTxn(id, subID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_txn_logs/` + id + '/' + subID
    );
  }

  getEntityAddress(entityid, sourceid): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_entity_address/` + sourceid + '/' + entityid
    );
  }

  geAlumniAddress(entityid, sourceid): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_alumni_address/` + sourceid + '/' + entityid
    );
  }

  getEntityContact(entityid, sourceid): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_entity_contact/` + sourceid + '/' + entityid
    );
  }

  getEntityFinance(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/get_entity_finance`, {
      params: param,
    });
  }

  getEntityFinanceReimbursement(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_entity_finance_reimburse`,
      {
        params: param,
      }
    );
  }
  getReimbursementBank(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/get_rembursement_bank`, {
      params: param,
    });
  }

  getSubDepartment(dptid): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_sub_departments/` + dptid
    );
  }
  getBanks(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_banks`);
  }
  getAccounts(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_account_type`);
  }
  getAccountTypes(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_account_type`);
  }
  getCostCenterExitEmp(ccID, mrfId = '0'): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_cost_center_exit_emp/` + ccID + '/' + mrfId
    );
  }
  getEmpCostCenters(roleID = ''): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_emp_cost_center?role_id=${roleID}`
    );
  }
  getEmpCostCenterTransfer(): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_emp_cost_center_transfer`
    );
  }
  getCostCenterSegment(segId): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_cost_center_by_segmemt/` + segId
    );
  }
  getEmpRolesCostCenters(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/get_emp_role_cost_center`,
      req
    );
  }
  getAllCostCenters(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_all_cost_center`);
  }
  getAllemps(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_all_employees`);
  }
  getAllRecriters(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_all_recruiters`);
  }

  getCostCenterEmployees(ccID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_cost_center_employees/` + ccID
    );
  }
  getCostCenterEmployeesExpMe(ccID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/talent/mrf/get_cost_center_employees_exp_me/` +
        ccID
    );
  }

  getCostCenterEmployeesNotInMrf(ccID, mrfID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_cost_center_employees_not_mrf/` +
        ccID +
        '/' +
        mrfID
    );
  }
  getTransferType(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_transfer_type`);
  }
  getSkillTypes(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_skill_type`);
  }
  getCostCenterSkill(ccId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_cost_center_skills/` + ccId
    );
  }
  getPoTypes(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/get_po_type`);
  }
  getPoTypesProv(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/get_po_type_prov`);
  }
  getDesignation(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_designation`);
  }
  getDepartments(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_departments`);
  }
  getSubDepartments(deptID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_sub_departments/` + deptID
    );
  }

  // job categ
  jobCategGet(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_job_cate`);
  }

  leaveTypeGet(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_leave_type`);
  }

  policyTypeGet(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_policy_type`);
  }

  // learning & Development

  topicsGet(catID): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_topics/` + catID);
  }

  categoryGet(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/select_categories`);
  }

  // compliance
  compliancecategoryGet(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/select_compliance_category`
    );
  }

  topicsCompGet(catID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/select_compliance_tpc/` + catID
    );
  }

  getUsrEvnts(events): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/user_events`, events);
  }

  getCostCenters(req = ''): Observable<any> {
    let param = new HttpParams();
    if (req != '') {
      param = param.append('is_excel', '1');
    } else {
      param = param.append('is_excel', '');
    }
    return this.http.get<any[]>(`${environment.apiUrl}/select_cost_center`, {
      params: param,
    });
  }

  getownerCostCenters(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_owner_cost_center`);
  }

  getEmpRolesCostCentersOwner(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/get_emp_role_cost_center_owner`,
      req
    );
  }

  checkCycle24(): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/check_cycle_24`);
  }
  checkCurrMonth(req): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/check_current_month`,
      req
    );
  }

  empBankDetail(data): Observable<any> {
    //   const option = {
    //     emp_id: data.userID,
    //     bulk_emp: data.bulkEmp,
    //     cc_id : data.ccID,
    //     page: data.page,
    //     limit: data.limit
    // };
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    // const options = new HttpParams({ fromObject: option });
    return this.http.get<any[]>(`${environment.apiUrl}/get_emp_bnk_report`, {
      params: param,
    });
  }
  isBaseRegular(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/is_base_regular`);
  }

  complaintGenerate(req: FormData): Observable<any> {
    return this.http.post<any[]>(
      `${this.supportURL}/create_ticket_crm.php`,
      req
    );
  }
  loginReports(req): Observable<any> {
    return this.http.post<any>(`${environment.apiUrl}/get_login_report`, req);
  }
  levelReports(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/get_emp_level`,
      req
    );
  }

  newHireReports(req): Observable<any> {
    return this.http.post<any>(
      `${environment.apiUrl}/mis-reports/new_hire_employee`,
      req
    );
  }

  getReleaseGroup(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/doa/get_release_group`
    );
  }

  addApprovalDOA(data): Observable<any[]> {
    if (!data.id) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/setups/doa/add_doa_approval`,
        data
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/setups/doa/edit_doa_approval_action`,
      data
    );
  }

  getApprovalDOA(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms !== '' &&
        data.forms !== undefined &&
        data.forms !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/doa/get_doa_approval`,
      { params: param }
    );
  }

  editApprovalDOA(mcId): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/doa/edit_doa_approval/` + mcId
    );
  }

  deleteApprovalDOA(ctid): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/setups/doa/delete_doa_approval`,
      { id: ctid }
    );
  }

  editApprovalDOAStatus(stat, mapID): Observable<any> {
    const option = {
      status: stat,
      id: mapID,
    };
    const options = new HttpParams({ fromObject: option });
    return this.http.post<any>(
      `${environment.apiUrl}/setups/doa/edit_doa_approval_status`,
      options
    );
  }

  getEmployeeRoleMenu(data): Observable<any[]> {
    let param = new HttpParams();
    for (const key in data.forms) {
      if (
        data.forms !== '' &&
        data.forms !== undefined &&
        data.forms !== null
      ) {
        param = param.append(key, data.forms[key]);
      }
    }
    if (
      'pageIndex' in data &&
      data.pageIndex !== '' &&
      data.pageIndex !== undefined
    ) {
      param = param.append('page', data.pageIndex);
    }
    if ('limit' in data && data.limit !== '' && data.limit !== undefined) {
      param = param.append('limit', data.limit);
    }
    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/doa/get_employee_role_menu`,
      { params: param }
    );
  }

  getTaskDoa(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/setups/doa/get_task_doa`
    );
  }

  addTaskDOA(data): Observable<any[]> {
    if (!data.id) {
      return this.http.post<any[]>(
        `${environment.apiUrl}/setups/doa/add_task_doa`,
        data
      );
    }
    return this.http.post<any[]>(
      `${environment.apiUrl}/setups/doa/edit_task_doa_action`,
      data
    );
  }

  withdrawTaskDOA(ctid): Observable<any[]> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/setups/doa/withdraw_task_doa`,
      { id: ctid }
    );
  }

  updateAdminDetail(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/update_emp_ext_date`,
      data
    );
  }

  reportFilterExitDateChange(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/talent/mrf/report_exit_date_change`,
      data
    );
  }

  bulkUpload(data): Observable<any> {
    return this.http.post<any[]>(
      `${environment.apiUrl}/update_bulk_role`,
      data
    );
  }

  getFiles(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_ramco_files_list`);
  }
  refreshFiles(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/` + data.url, { params: param } ); //{ params: param }
  }

  getUserMisFilter(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/getUserCateMisFilter`);
  }

  hseCategoryGet(): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/survey/hse/select_hse_category`
    );
  }

  hseTopicsGet(catID): Observable<any[]> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/survey/hse/select_hse_topic/` + catID
    );
  }

  getPcByCat(cate): any {
    return new Promise((resolve) => {
      // tslint:disable-next-line: deprecation
      this.http
        .get(`${environment.apiUrl}/get_plants_by_cat/` + cate)
        .subscribe(
          (data) => {
            resolve(data);
          },
          (err) => {
            resolve(false);
          }
        );
    });
  }

  getPcCate(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/get_pc_cate`);
  }

  getMostContact(): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/getMostContact`);
  }
  getUserPcCodes(data = {}): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/shared/get-user-pc-code`,{
        params: param,
      }
    );
  }
  getPcLocation(pcID,data={}): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/shared/get-pc-locations/`  +  pcID, {
        params: param,
      }
    );
  }
  getInternEmps(req): Observable<any>{
    return this.http.post<any>(`${environment.apiUrl}/intern_search_all`, req);
  }

  upldRamcoEmployee(data): Observable<any>{
    return this.http.post<any>(`${environment.apiUrl}/upload_ramco_employee`,data);
  }
  getTemplateUrl(tempName): Observable<any> {
    return this.http.get<any[]>(
      `${environment.apiUrl}/get_template_url/` + tempName
    );
  }
  getBiometricCategories(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_biometric_category` );
  }
  getactCostEmp(): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_active_cost_emp` );
  }

  addBiometricRequest(data,bm_id): Observable<any>{
    if (bm_id !== '' && bm_id !== null)
    {
      return this.http.post<any>(`${environment.apiUrl}/update_biometric_request/${bm_id}`,data);
    }
    else
    {
      return this.http.post<any>(`${environment.apiUrl}/add_biometric_request`,data);
    }
  }

  biometricRequest(data): Observable<any>{
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/get_biometric_request`,{params:param} );
  }

  editBm(id): Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/edit_biometric_request/${id}`);
  }
  approveRejBm(reqID,status): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/apprej_biometric_request/${reqID}/${status}`);
  }

  downloadBmReport():Observable<any>{
    return this.http.get(`${environment.apiUrl}/get_bm_report`);

  }

  ShowContactBm():Observable<any>{
    return this.http.get(`${environment.apiUrl}/get_bm_contact`);

  }

  dispatchBmAdd(req):Observable<any>{
    return this.http.post<any[]>(
      `${environment.apiUrl}/add_dispatch_biometric`,
      req
    );

  }

  getBiometricDispatch(data): Observable<any>{
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any[]>(`${environment.apiUrl}/get_biometric_dispatch`,{params:param} );
  }
  changeDispatchStatus(bh_id, status): Observable<any[]> {
    return this.http.get<any[]>(`${environment.apiUrl}/approve_reject_dispatch/${bh_id}/${status}`);
  }

  dispatchReport():Observable<any>{
    return this.http.get(`${environment.apiUrl}/get_dispatch_report`);

  }

  editDispatchOrder(bh_id):Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/edit_dispatch_biometric/${bh_id}`);

  }

  dispatchBmUpdate(req):Observable<any>{
    return this.http.post<any[]>(
      `${environment.apiUrl}/update_dispatch_biometric`,
      req
    );

  }

  // tslint:disable-next-line: typedef
  getAllProject(projectID) {
    return new Promise((resolve) => {
      this.http.get(`${environment.apiUrl}/get_project_menu/` + projectID).subscribe(
        (data) => {
          resolve(data);
        },
        (err) => {
          resolve(false);
        }
      );
    });
    // return this.http.get<any[]>(`${environment.apiUrl}/get_app_menu/` + appID);
  }

  onChangegetActEmp(cc_id): Observable<any> {
    return this.http.get<any[]>(`${environment.apiUrl}/get_active_cost_emp/${cc_id}` );
  }
  pcCodeWiseDispatch(pc_id):Observable<any>{
    return this.http.get(`${environment.apiUrl}/pccode_wise_dispatch/${pc_id}`);
  }

  signOffRequest(data):Observable<any>{
    return this.http.post(`${environment.apiUrl}/update_sign_off_rqst`,data);
  }

  printsignOffRequest(data):Observable<any>{
    return this.http.post<any[]>(`${environment.apiUrl}/print_sign_off_rqst`,data );
  }

  getAssetReceiptData(reqId):Observable<any>{
    return this.http.get(`${environment.apiUrl}/get_fixed_asset_recpt/${reqId}`);
  }

  addSystem(data): Observable<any>{
    return this.http.post(`${environment.apiUrl}/add_system_action`,data);

  }

  getEmployeeSystem(): Observable<any>{
    return this.http.get(`${environment.apiUrl}/get_employee_system`);
  }

  editEmployeeSystem(id):Observable<any>{
    return this.http.get(`${environment.apiUrl}/edit_employee_system/${id}`);
  }

  assignedtoEmp(data): Observable<any>{
    return this.http.post(`${environment.apiUrl}/assigned_system_to_emp`,data);
  }

  getEmpLapHstry(sysId): Observable<any>{
    return this.http.get<any[]>(`${environment.apiUrl}/get_emp_laptop_hstry/${sysId}`);
  }

  getSystemReport():Observable<any>{
    return this.http.get(`${environment.apiUrl}/get_emp_system_report`);
  }

  addSystemExpns(data):Observable<any>{
    return this.http.post(`${environment.apiUrl}/add_emp_system_expns`,data);
  }

  viewSystemExpns(sysId):Observable<any>{
    return this.http.get(`${environment.apiUrl}/get_emp_system_expns/${sysId}`);
  }

  updateStemExpns(data):Observable<any>{
    return this.http.post(`${environment.apiUrl}/update_system_expense`,data);
  }

}
